import React from 'react';
import './Stats.css';

const Stats = () => {
  return (
    <section className="stats">
      <div className="stats-bg-pattern"></div>
      <div className="container stats-container">
        <div className="stats-header">
          <h2 className="stats-title">
            Driving Digital Growth Globally
          </h2>
          <p className="stats-subtitle">
            At Nodex Global LLC, we let our results do the talking. Our numbers reflect our commitment to excellence.
          </p>
        </div>
        
        <div className="stats-grid">
          <div className="stat-item">
            <h3 className="stat-number">10+</h3>
            <p className="stat-label">Years of<br/>Excellence</p>
          </div>
          <div className="stat-item">
            <h3 className="stat-number">500+</h3>
            <p className="stat-label">Happy Clients<br/>Worldwide</p>
          </div>
          <div className="stat-item">
            <h3 className="stat-number">14+</h3>
            <p className="stat-label">Countries With<br/>Active Clients</p>
          </div>
          <div className="stat-item">
            <h3 className="stat-number">4.9/5</h3>
            <p className="stat-label">Average<br/>Customer Rating</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
